import "../chunk-BUSYA2B4.js";
import { AsyncLocalStorage } from "node:async_hooks";
const clerkMiddlewareRequestDataStore = /* @__PURE__ */ new Map();
const clerkMiddlewareRequestDataStorage = new AsyncLocalStorage();
export {
  clerkMiddlewareRequestDataStorage,
  clerkMiddlewareRequestDataStore
};
//# sourceMappingURL=middleware-storage.js.map